import axios from 'axios';

export default {
  namespaced: true,
  state: {
    all: {},
    options: ['Dubbel', 'Enkelwerkend'],
    remotes: [
        {
          key: 0,
          value: 'Handbediening'
        },
        {
          key: 12,
          value: '12V'
        },
        {
          key: 24,
          value: '24V'
        },
        {
          key: 230,
          value: '230V'
        },
      ]
  },

  getters: {
    getAll(state) {
      return state.all;
    },

    getRemotes(state) {
      return state.remotes;
    }
  },

  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'valves')
        .then(({ data }) => {
          commit('setValves', data);
        });
    },
  },

  mutations: {
    setValves(state, valves) {
      let val = {};
      valves.forEach((v) => {
        val[v.id] = v;
      });
      state.all = val;
    },
  },
};
